/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GraduatoriaEligibilitaNodoForm } from './graduatoria-eligibilita-nodo-form';
import { LimiteAssegnazione } from './limite-assegnazione';


export interface GraduatoriaRicalcoloForm { 
    eligibilita?: Array<GraduatoriaEligibilitaNodoForm>;
    override_budget_totale?: number;
    override_limite_assegnazione?: LimiteAssegnazione;
    override_numero_massimo_beneficiari?: number;
}



